import { useMutation, type UseMutationResult } from '@tanstack/react-query';

type SupportTeamsBodyRequest = {
    aflTeamOfSupport: string | null;
    bblTeamOfSupport: string | null;
}

const useSupportTeamsMutation = (): UseMutationResult<UseMutationResult, unknown, SupportTeamsBodyRequest> => {
    const endpoint = '/api/Members/current/supportteams';

    const mutation = useMutation({
        mutationFn: async(data: SupportTeamsBodyRequest): Promise<UseMutationResult> => {
            const response = await fetch(endpoint, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' },
            });

            if (!response.ok) {
                if (response.status === 400) {
                    const errorResponse = await response.json();
                    throw new Error(errorResponse.errorMessages?.[0] || 'Validation error occurred');
                }

                throw new Error('Unable to submit form');
            }

            const responseData = await response.json();

            if (!responseData.isSuccess) {
                throw new Error(`Form submission failed: ${responseData.errorMessages?.[0] || 'Unknown error'}`);
            }

            return responseData.data;
        },

    });

    return mutation;
};

export default useSupportTeamsMutation;
